import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Users from './views/Users.vue'
import store from '@/state/store'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    component: Login,
    meta: { requiresUnauth: true }
  },
  {
    path: '/users',
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/experience_overview',
    name: 'ExperienceOverview',
    component: () => import('./views/ExperienceOverview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/edit_step',
    name: 'EditStepPage',
    component: () => import('./views/EditStepPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/space_overview',
    name: 'SpaceOverview',
    component: () => import('./views/SpaceOverview.vue'),
    meta: { requiresAuth: true }
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isLoggedIn) {
    return next("/login")
  }

  if (to.matched.some(record => record.meta.requiresUnauth) && store.getters.isLoggedIn) {
    return next("/")
  }

  next();
})

export default router